import { PlusOutlined } from '@ant-design/icons';
import { Button, Card } from 'antd';
import React, { useContext, useState } from 'react';
import { AppContext } from '../../../AppContext';
import {
  MODULES,
  PERMISSIONS_KEY,
  PERMISSION_TYPE,
} from '../../../common/constants';
import { hasPermission } from '../../../common/utils';
import Portal from '../../../components/Portal';
import MediaLibraryTable from '../components/MediaLibraryTable';

const MediaLibrary = () => {
  const {
    state: { permissions },
  } = useContext(AppContext);
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);

  const canCreate = hasPermission(
    PERMISSIONS_KEY?.MASTER_LIST_MEDIA_UPLOAD,
    PERMISSION_TYPE?.CREATE,
    permissions,
  );

  const UploadButton = () =>
    canCreate && (
      <Button
        className="common-button"
        size="middle"
        icon={<PlusOutlined />}
        onClick={() => setIsUploadModalOpen(true)}
      >
        Upload Media
      </Button>
    );

  return (
    <>
      <Portal portalId="header-title-content">
        <div className="portal-header">{MODULES?.MEDIA_LIBRARY}</div>
      </Portal>
      <Portal portalId="header-right-content">
        <UploadButton />
      </Portal>
      <Portal portalId="header-right-content-phones">
        <UploadButton />
      </Portal>
      <Card className="full-height-without-nav">
        <MediaLibraryTable
          isUploadModalOpen={isUploadModalOpen}
          setIsUploadModalOpen={setIsUploadModalOpen}
        />
      </Card>
    </>
  );
};

export default MediaLibrary;
